<ion-select
  (ionChange)="selectUser($event)"
  [interfaceOptions]="{ cssClass: 'action-sheet-eventslight' }"
  [value]="selectedUserId"
  class="action-sheet-eventslight"
  data-cy="select-crew"
  interface="action-sheet"
  placeholder="-"
  >

  <ion-select-option [value]="null">
    -
  </ion-select-option>

  @for (user of filteredUsers; track user) {
    <ion-select-option [value]="user.id">
      {{ user.firstName }} {{ user.lastName }}
    </ion-select-option>
  }
</ion-select>

<ng-content />
